import React from "react";

const SurrenderOfShares = () => {
  return <div>SurrenderOfShares</div>;
};

export default SurrenderOfShares;
